import React, { Component } from 'react'
import ImageGallery from 'react-image-gallery'
import yn from 'yn'
import get from 'lodash/get'

import BkFlowRoomCardMediaGalleryFeatureToggles from './BkFlowRoomCardMediaGalleryFeatureToggles'

class BkFlowRoomCardMediaGallery extends Component {
	constructor(props) {
		super(props)

		this.state = {
			isRoomFloorPlanVisible: false,
		}

		this.handleOverlayClick = this.handleOverlayClick.bind(this)
		this.onViewFloorPlan = this.onViewFloorPlan.bind(this)
		this.renderImageGalleryFullScreenButton = this.renderImageGalleryFullScreenButton.bind(this)
	}

	handleOverlayClick(event) {
		const target = event.target

		if (target.classList.contains('fullscreen-modal')) {
			this.setState({ isRoomFloorPlanVisible: false })
			this.imageGallery.exitFullScreen()
		}
	}

	onViewFloorPlan() {
		this.setState({ isRoomFloorPlanVisible: true })
		this.imageGallery.fullScreen()
	}

	renderImageGalleryFullScreenButton(onClick, isFullScreen) {
		const { renderFullScreenButton } = this.props

		const onClickFullScreenButton = () => {
			this.setState({ isRoomFloorPlanVisible: false })
			onClick()
		}
	
		return renderFullScreenButton(onClickFullScreenButton, isFullScreen)
	}

	render() {

		const {
			cards,
			enableBullets,
			fullScreenEvent,
			gallery,
			hotelLabels,
			imageClickEvent,
			isFullScreen,
			quantityNotifications,
			virtualTourEvent,
		} = this.props
		const { isRoomFloorPlanVisible } = this.state


		const floorPlanSrc = get(cards, 'viewExtensions.roomFloorPlanSrc.path')
		const floorPlan = floorPlanSrc
			? [{
					caption: 'Floor Plan',
					description: 'Floor Plan',
					original: floorPlanSrc
				}]
			: []
		const images = isRoomFloorPlanVisible ? floorPlan : gallery
		const fullScreenGalleryClassName = isRoomFloorPlanVisible
				? 'bk-flow-room__card-media card-media-floor-plan u-remove-padding gallery-open u-bg-image'
				: 'bk-flow-room__card-media u-remove-padding gallery-open u-bg-image'

		return (
			<div
				className={
					isFullScreen
						? fullScreenGalleryClassName
						: 'bk-flow-room__card-media u-remove-padding'
				}
				onClick={ this.handleOverlayClick }
				style={ isFullScreen ? { backgroundImage: 'url(' + gallery[0].original + ')' } : null }
			>
				<ImageGallery
					ref={ i => this.imageGallery = i }
					onScreenChange={ fullScreenEvent }
					additionalClass={ isFullScreen ? 'fullscreen' : 'preview' }
					items={ images }
					infinite={ true }
					slideDuration={ isRoomFloorPlanVisible ? 0 : 450 }
					showThumbnails={ false }
					showPlayButton={ false }
					showBullets={ enableBullets && images.length > 1 ? true : false }
					renderFullscreenButton={ this.renderImageGalleryFullScreenButton }
					useBrowserFullscreen={ false }
					onClick={ imageClickEvent }
				/>

				{ yn(process.env.REACT_APP_COMPONENT_ROOM_IMAGE_FEATURE_TOGGLES) &&
					<BkFlowRoomCardMediaGalleryFeatureToggles
						cards={cards}
						hotelLabels={hotelLabels}
						onViewFloorPlan={this.onViewFloorPlan}
						virtualTourEvent={virtualTourEvent}
					/>
				}

				{ yn(process.env.REACT_APP_COMPONENT_ROOM_QUANTITY_NOTIFICATIONS) && quantityNotifications }
			</div>
		)
		}
}


export default BkFlowRoomCardMediaGallery


// WEBPACK FOOTER //
// ./src/components/room/elements/gallery/BkFlowRoomCardMediaGallery.js